import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type QuestionsTemplate from 'modules/surveys/store/models/QuestionsTemplate'

interface Props {
  questionsTemplate: QuestionsTemplate
}

function BasicInfo({ questionsTemplate }: Props) {
  const form = React.useRef(
    new Form(
      {
        title: questionsTemplate.attributes.title,
      },
      {
        title: 'string',
      }
    )
  ).current

  const { performAction: submit, running } = useAsyncAction(() => form.save(questionsTemplate))

  const defaultTemplate = questionsTemplate.isDefault

  const defaultDescription = i18n.t(
    'app_store_v2.apps.performance_v2.settings.templates.default.description'
  )

  const basicDescription = i18n.t(
    'app_store_v2.apps.performance_v2.settings.templates.new.basic_description'
  )

  const description = defaultTemplate ? defaultDescription : basicDescription

  return (
    <Box gap="s16" flexDirection="row">
      <Box flexGrow>
        <PanesHeader
          illustration="settings"
          title={i18n.t('app_store_v2.apps.performance_v2.settings.templates.new.basic_info')}
          description={description}
        />
      </Box>
      <Box
        gap="s8"
        justifyContent="center"
        background="grey200"
        borderRadius={{ all: 'abs004' }}
        padding="s32"
        height="min-content"
      >
        <TextInput
          field={form.get('title')}
          readonly={defaultTemplate}
          label={i18n.t('app_store_v2.apps.performance_v2.settings.templates.new.label')}
        />
        {form.get('title').isDirty && (
          <Box alignItems="flexEnd">
            <Button onClick={submit} disabled={running}>
              {i18n.t('app_store_v2.apps.performance_v2.settings.templates.edit.label')}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default observer(BasicInfo)
